import React from "react";
import { createBrowserRouter, Navigate} from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import TestimonialsPage from "../pages/TestimonialPage";
import AdminPortfolio from "../pages/AdminPortfolio";
import GalleryPage from "../pages/GalleryPage";
import PropertyOverview from "../pages/PropertyOverview";
import PropertyListing from "../pages/PropertyListing";
import NotFound from "../pages/NotFound";

// Policy Pages
import PrivacyPolicy from "../pages/policyPages/PrivacyPolicy";
import TermsAndConditions from "../pages/policyPages/TermsAndConditions";


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
       path:"properties",
       element:<PropertyListing/>
      },
      {
        path: "properties/overview/:id",
        element: <PropertyOverview />,
      },
      {
        path: "about-us",
        element: <AboutPage />,
      },
      {
        path: "contact-us",
        element: <ContactPage/>,
      },
      {
        path: "testimonials",
        element: <TestimonialsPage />,
      },
      {
       path:"gallery",
       element:<GalleryPage/>
      },
      {
        path: "portfolio",
        element: <AdminPortfolio />,
      },

      {
        path: "policy",
        children: [
          { index: true, element: <Navigate to="privacy-policy" replace /> },
          { path: "privacy-policy", element: <PrivacyPolicy /> },
          { path: "terms-conditions", element: <TermsAndConditions /> },
        ]
      },

      {
        path: "*",
        element: <NotFound />,
      }
    ],
  },
]);

export default router;